import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  validatePassword,
  validateConfirmPassword,
} from "../../Utils/Validation.jsx";
import { resetPasswordAPI } from "../../Services/authService.js";
import { Button } from "../ui/Button/index";
import { useTranslation } from "react-i18next";

function ResetPasswordForm() {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const { token } = useParams(); // Access the token from URL params

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Get the current URL
    const currentUrl = window.location.href;

    // Use URLSearchParams to get query parameters
    const urlParams = new URLSearchParams(currentUrl.split("?")[1]);

    // Fetch the token from query parameters
    const token = urlParams.get("token");
    const passwordValidationError = validatePassword(password);
    const confirmPasswordValidationError = validateConfirmPassword(
      password,
      confirmPassword
    );

    if (passwordValidationError || confirmPasswordValidationError) {
      setPasswordError(passwordValidationError);
      setConfirmPasswordError(confirmPasswordValidationError);
      setMessage(t("career.fixErrors"));
    } else {
      setPasswordError("");
      setConfirmPasswordError("");
      setMessage("");

      if (password !== confirmPassword) {
        setMessage(t("career.passwordsDontMatch"));
        return;
      }

      try {
        const response = await resetPasswordAPI(password, token);
        setMessage(response.message);
        setPassword("");
        setConfirmPassword("");
        setTimeout(() => {
          window.location.href = "/login";
        }, 3000);
      } catch (error) {
        setMessage(error.response.data.error);
      }
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="mx-auto max-w-md p-8 bg-white rounded shadow-lg">
        <div className="text-2xl mb-4 font-bold">{t("career.resetPwTitle")}</div>
        <div className="mb-6 text-gray-600">
          {t("career.resetPwDesc")}
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="password">{t("career.newPassword")}</label>
            <input
              id="password"
              type="password"
              placeholder={t("career.enterNewPassword")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="border border-gray-300 rounded px-3 py-2 w-full"
            />
            {passwordError && (
              <p className="text-red-500 text-sm">{passwordError}</p>
            )}
          </div>
          <div className="space-y-2">
            <label htmlFor="confirmPassword">{t("career.confirmNewPassword")}</label>
            <input
              id="confirmPassword"
              type="password"
              placeholder={t("career.confirmNewPassword")}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="border border-gray-300 rounded px-3 py-2 w-full"
            />
            {confirmPasswordError && (
              <p className="text-red-500 text-sm">{confirmPasswordError}</p>
            )}
          </div>
          <Button
            type="submit"
            variant="primary"
            size="md"
            fullWidth
          >
            {t("career.resetPassword")}
          </Button>
          {message && <p className="mt-4 text-green-500">{message}</p>}
        </form>
      </div>
    </div>
  );
}

export default ResetPasswordForm;
